import type { NativeBridge, PushApi } from "@agentsaas/mobile/bridge";
import type { ApiClient } from "@agentsaas/client-sdk";
import { negotiateLocale } from "@agentsaas/i18n";

/**
 * 原生壳（packages/mobile，Capacitor）接缝：window.__nativeBridge 存在时
 * - 鉴权改用 bearer + refresh（tokenAuth + 桥的 Keychain/Keystore tokenStore），登录 / 注册带 mode: "token"
 * - 推送走 APNs / FCM（桥注册设备），不注册 service worker、不走 Web Push
 * 浏览器 / PWA 里它是 undefined，行为不变。契约见 packages/mobile/src/bridge/types.ts。
 */

export type { NativeBridge };

export function nativeBridge(): NativeBridge | undefined {
  return typeof window === "undefined" ? undefined : window.__nativeBridge;
}

/** 桥不持有 API 客户端：deviceRegister / deviceDelete 由 web 代调 */
export function pushApiFor(api: ApiClient): PushApi {
  return {
    // 桥给的 locale 是字符串，按支持的语言协商一次
    registerDevice: (body) => api.call("deviceRegister", { body: { ...body, locale: negotiateLocale(body.locale) } }),
    deleteDevice: (did) => api.call("deviceDelete", { params: { did } }),
  };
}
